export const authImages = {
  mainImage: 'assets/img/auth/auth-img.png',
  cross: 'assets/img/auth/cross.svg',
  hiddenEye: 'assets/img/auth/hided_eye.svg',
  openEye: 'assets/img/auth/open_eye.svg',
  google: 'assets/img/auth/logo.svg'
};

export const ubsAuthImages = {
  mainImage: 'assets/img/ubs/Garbage_Bag_Green.svg',
  cross: 'assets/img/auth/cross.svg',
  hiddenEye: 'assets/img/auth/hided_eye.svg',
  openEye: 'assets/img/auth/open_eye.svg',
  google: 'assets/img/auth/logo.svg'
};
